// File: src/ErrorFallback.tsx
import React from 'react'

interface Props {
  error: unknown
  resetErrorBoundary: () => void
}

export function ErrorFallback({ error, resetErrorBoundary }: Props) {
  const isDevelopment = import.meta.env.DEV;

  return (
    <div style={{ padding: 20, fontFamily: 'sans-serif' }}>
      <h1>🚨 Something went wrong</h1>

      {isDevelopment ? (
        <details style={{ whiteSpace: 'pre-wrap', background: '#fee', padding: 10 }}>
          <summary>Error details</summary>
          <pre>
            {JSON.stringify(
              error,
              Object.getOwnPropertyNames(error as object),
              2
            )}
          </pre>
          <pre>{error instanceof Error ? error.stack : String(error)}</pre>
        </details>
      ) : (
        <p>Please refresh the page. If the issue continues, contact an administrator.</p>
      )}

      <button onClick={resetErrorBoundary} style={{ marginTop: 20 }}>
        Try again
      </button>
    </div>
  )
}
